import { cn } from '@/shared/cn';
import type { ReconRow } from '@/shared/api';

const STATE_STYLES: Record<ReconRow['resolution_state'], { label: string; cls: string }> = {
  pending_maker:       { label: 'Awaiting maker',    cls: 'bg-axis-cloud-100 text-axis-ash border border-axis-cloud-200' },
  pending_checker:     { label: 'Awaiting checker',  cls: 'bg-amber-100 text-amber-800 border border-amber-200' },
  approved:            { label: 'Approved',          cls: 'bg-emerald-100 text-emerald-800 border border-emerald-200' },
  rejected_by_checker: { label: 'Rejected by checker', cls: 'bg-rose-100 text-rose-800 border border-rose-200' },
  rejected_by_maker:   { label: 'Rejected by maker', cls: 'bg-axis-cloud-100 text-axis-ash border border-axis-cloud-200' },
  applied:             { label: 'Applied',           cls: 'bg-emerald-200 text-emerald-900 border border-emerald-300' },
};

export function ResolutionPill({ state }: { state: ReconRow['resolution_state'] }) {
  const s = STATE_STYLES[state] ?? { label: state, cls: 'bg-axis-cloud-100 text-axis-ash' };
  return <span className={cn('pill', s.cls)}>{s.label}</span>;
}
